import React, {useRef, useState} from 'react';
import {Link, NavLink} from "react-router-dom";
import emailjs from '@emailjs/browser';
import styles from "./orderSection.module.sass"
import line_order from "../../assets/line_order.png"
import black_logo_order from "../../assets/black_logo_order.png"
import WA from "../../assets/WA.png"
import Vk from "../../assets/VK.png"
import TG from "../../assets/TG.png"
import Phone from "../../assets/Phone.png"
import line from "../../assets/Line 16.png"
import galochka from "../../assets/galochka 1.png";

export const OrderSection = () => {

    const [active, setActive] = useState("");

    const handleClick = (event : any) => {
        let checkboxElem = document.getElementById('checkbox') as HTMLInputElement;
        let checkboxElemClass = checkboxElem.className
        if (checkboxElemClass == 'active') {
            checkboxElem.classList.remove('active')
            setTimeout(() => { activeCheckboxCheck()}, 1);
        } else {
            setActive(event.target.id);
            setTimeout(() => { activeCheckboxCheck()}, 1);
        }
    }

    const activeChange = () => {
        let checkboxElem = document.getElementById('checkbox') as HTMLInputElement;
        let checkboxElemClass = checkboxElem.className
        if (checkboxElemClass == 'active') {
            checkboxElem.classList.remove('active')
            setTimeout(() => { activeCheckboxCheck()}, 1);
        } else {
            checkboxElem.classList.add('active')
            setTimeout(() => { activeCheckboxCheck()}, 1);
        }
    }

    const activeCheckboxCheck = () => {
        let checkboxElem = document.getElementById('checkbox') as HTMLInputElement;
        let galochka = document.getElementById('galochka') as HTMLInputElement;
        let checkboxElemClass = checkboxElem.className
        if (checkboxElemClass == 'active') {
            galochka.style.display = 'block'
        } else if (checkboxElemClass == '') {
            galochka.style.display = 'none'
        }
    }

    const callCheck = () => {
        if (window.innerWidth > 700) {
            let phoneButton = document.getElementById('orderPhone') as HTMLButtonElement;
            phoneButton.disabled = true
            alert("Звонок возможен только с мобильного устройства." +
                " Воспользуйтесь мобильной версией либо совершите звонок скопировав номер в буфер обмена")
        } else {
            let phoneButton = document.getElementById('orderPhone') as HTMLButtonElement;
            phoneButton.click()
        }
    }

    const sendEmail = (e : any) => {
        let check1 = document.getElementById('name') as HTMLInputElement;
        let check2 = document.getElementById('phone') as HTMLInputElement;
        let checkboxElem = document.getElementById('checkbox') as HTMLInputElement;
        let checkboxElemClass = checkboxElem.className
        let value1 = check1.value
        let value2 = check2.value
        if (value1 !== '' && value2 !== '' && checkboxElemClass == 'active') {
            e.preventDefault();
            let formElement = document.getElementById('form') as HTMLFormElement;
            emailjs
                .sendForm
                ('service_v3nribe',
                    'template_njnziyy',
                    formElement,
                    'W4gaNxVQQSGKE2skw')
                .then
                ((result) => {
                    alert("Заявка успешно отправлена")
                }, (error) => {
                    alert("Произошла ошибка, попробуйте снова")
                });
        } else if(!(value1 !== '' && value2 !== '')) {
            alert("Заполните поля для отправки заявки")
        } else if (!(checkboxElemClass == 'active')) {
            alert('Примите пользовательское соглашение для отправки заявки.')
        }

    }


    const scrollToElement = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className={styles.section__order__wrap} id='sectionOrder'>
            <div className={styles.section__order__headerWrap}>
                <span className={styles.section__order__headerText}>Отправьте нам заявку и мы свяжемся с вами</span>
                <img className={styles.section__order__lineImg} src={line} alt=""/>
            </div>
            <div className={styles.section__order}>
                <div className={styles.section__order__elem1}>
                    <form id='form' onSubmit={sendEmail} className={styles.section__order__formFields}>
                        <div className={styles.section__order__elem1TextWrap}><span className={styles.section__order__elem1Text}>ОСТАВЬТЕ ЗАЯВКУ</span></div>
                        <span className={styles.section__order__fieldText}>ВАШЕ ИМЯ</span>
                        <div className={styles.section__order__fieldWrap} >
                            <label className={styles.section__order__field} htmlFor="">
                                <input
                                    onKeyPress={(event) => {
                                        if (!/[а-яё,A-ЯЁ]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className={styles.section__order__innerInput} id='name' name="name" placeholder={"Иван"} type="text"/>
                            </label>
                        </div>
                        <span className={styles.section__order__fieldText}>ВАШ ТЕЛЕФОН</span>
                        <div  className={styles.section__order__fieldWrap}>
                            <label className={styles.section__order__field} htmlFor="">
                                <input
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className={styles.section__order__innerInput} id='phone' name="phone" placeholder={"+7(906)-999-99-99"} type="text"/>
                            </label>
                        </div>
                        <div className={styles.section__order__termsBlock}>
                            <input className={active === "checkbox" ? "active" : undefined}
                                   id={"checkbox"}
                                   onClick={activeChange}
                                   type="checkbox"></input>
                            <img id='galochka' onClick={activeChange} className={styles.section__order__galochka} src={galochka} alt=""/>
                            <span className={styles.section__order__textDefault}>
                                Принимаю условия пользовательского соглашения
                            </span>
                        </div>
                        <div className={styles.section__order__fieldWrap}>
                            <NavLink to={'/Terms#termsHeader'} onClick={() => scrollToElement('termsHeader')}>
                                <button className={styles.section__order__buttonTerms}>
                                    <span className={styles.section__order__text}>
                                        Пользовательское соглашение
                                    </span>
                                </button>
                            </NavLink>
                        </div>
                        <div className={styles.section__order__buttonWrap}>
                            <button id='buttonSend' className={styles.section__order__button} type="submit" value="Send">
                                <span className={styles.section__order__buttonText}>ОТПРАВИТЬ</span>
                            </button>
                        </div>
                    </form>
                </div>
                <div className={styles.section__order__elem2}>
                    <div className={styles.black__logo__orderWrap}>
                        <img className={styles.black__logo__order} src={black_logo_order} alt=""/>
                    </div>
                    <span className={styles.section__order__elem2Text1}>
                    Оставьте свою заявку, чтобы мы могли связаться с вами и ответить на все ваши вопросы
                </span>
                    <img className={styles.line__order} src={line_order} alt=""/>
                    <span className={styles.section__order__elem2Text2}>Мы свяжемся с вами как можно скорее</span>
                </div>
                <div className={styles.section__order__elem3}>
                    <div className={styles.section__order__cardImgWrap}>
                        <div className={styles.section__order__cardImg}>
                            <div className={styles.section__order__cardFilter}></div>
                            <span className={styles.section__order__ImgText1}>Город Уфа:</span>
                            <span className={styles.section__order__ImgText2}>+7 (987) 254-88-54</span>
                            <span className={styles.section__order__ImgText3}>Город Казань:</span>
                            <span className={styles.section__order__ImgText4}>+7 (987) 215-05-06</span>
                        </div>
                    </div>
                    <div className={styles.section__order__socialsGroup}>
                        <a href="https://wa.me/79872548854" target='_blank'>
                            <button>
                                <div className={styles.section__order__socialsWU}>
                                    <img className={styles.section__order__socialIMG} src={WA} alt=""/>
                                </div>
                            </button>
                        </a>
                        <a href="https://vk.com/vashevelichie_ru" target='_blank'>
                            <button>
                                <div className={styles.section__order__socialsVK}>
                                    <img className={styles.section__order__socialIMG} src={Vk} alt=""/>
                                </div>
                            </button>
                        </a>
                        <a id='orderTg' href="https://t.me/vashe_velichie_kazan" target="_blank">
                            <button>
                                <div className={styles.section__order__socialsTG}>
                                    <img className={styles.section__order__socialIMG} src={TG} alt=""/>
                                </div>
                            </button>
                        </a>
                        <button onClick={callCheck}>
                            <div  className={styles.section__order__socialsPhone}>
                                <a className={styles.section__order__phoneA} id='orderPhone' href="tel:+79872150506">
                                    <img className={styles.section__order__socialIMG} src={Phone} alt=""/>
                                </a>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

